import $ from 'jquery';
import React from 'react';
import { translate } from 'react-i18next';

import {
  accordionInit,
  contentListItemColor,
  initModalRevealsForArticle,
  initTwoClickIframes
} from '../../articleHelper';
import ArticlePresenter from '../../articlePresenter';
import { ArticleImage, loadLargeImage } from '../articleImage';
import CallToAction from '../callToAction';
import ConsultantTeaser from '../consultantTeaser';
import FormRenderer from '../forms/formRenderer';
import ListTeaser from '../listTeaser';
import VideoRenderer from '../videos/videoRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';
import RepresentativeOffice from './RepresentativeOffice';
import HorizontalArticles from './horizontalArticles';

class BranchArticle extends React.Component {
  constructor() {
    super();
    this.state = {
      article: ArticlePresenter.nullArticle(),
      widgets: []
    };
  }

  componentDidMount() {
    this.ajaxArticle();
  }

  ajaxArticle() {
    const methods = [
      'title',
      'content',
      'context_info',
      'summary',
      'call_to_action',
      'image_links_mobil_oben_content',
      'image_alt_links_mobil_oben',
      'image_links_mobil_unten_content',
      'image_alt_links_mobil_unten',
      'image_rechts_mobil_oben_content',
      'image_alt_rechts_mobil_oben',
      'image_rechts_mobil_unten_content',
      'image_alt_rechts_mobil_unten',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background',
      'show_event_section',
      'branch',
      'branch.whofinance',
      'branch.location',
      'image_videovorschau_content',
      'image_alt_videovorschau',
      'vimeo_video',
      'youtube_video',
      'video_position',
      'widget_ids'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getArticle(data) }, function () {
            loadLargeImage(this);
            contentListItemColor();
            VideoRenderer.renderVideoModal(this.state.article.vimeoVideo);
            VideoRenderer.renderVideoModal(this.state.article.youtubeVideo);
            WidgetRenderer.widgetsForObject(this.state.article, (widgets) => {
              this.setState({ widgets }, () => {
                initModalRevealsForArticle(this.props.articleId);
                accordionInit();
                initTwoClickIframes();
              });
            });
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    return (
      <div className="background-fixed" style={this.state.article.imageBackground}>
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className="content">
              <div className="row">
                <MainContent article={this.state.article} widgets={this.state.widgets} />
                <FurtherContent article={this.state.article} widgets={this.state.widgets} />
              </div>

              <div className="row">
                <div className="margin-bottom-lg clearfix" />
              </div>

              <div className="row">
                <Consultants
                  consultantIds={this.state.article.branch.consultant_article_ids}
                  parentArticleId={this.props.articleId}
                />
              </div>
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>

        <Summary article={this.state.article} />
        <HorizontalArticles articleId={this.props.articleId} withParentArticle={false} />

        <RepresentativeOffice
          t={this.props.t}
          representativeOffice={this.state.article.branch.linked_branch}
        />

        <Events
          t={this.props.t}
          showEventSection={this.state.article.show_event_section}
          eventIds={this.state.article.branch.event_article_ids}
          parentArticleId={this.props.articleId}
          branchCity={this.state.article.branch.city}
          article={this.state.article}
        />
      </div>
    );
  }
}

BranchArticle.propTypes = {
  t: React.PropTypes.func,
  articleId: React.PropTypes.number
};

function MainContent({ article, widgets }) {
  function whofinanceWidget() {
    if (!article.branch.whofinance) {
      return null;
    }

    const scriptSrc = `
      https://www.whofinance.de/wfwidget/office/
      ${article.branch.whofinance}/QuirinSmallWidget.js
    `;

    return (
      <div>
        <div className="WhoFinance_Widget_container">
          <div id="WhoFinance_QuirinSmallWidget_container" />
        </div>
        <script
          src={scriptSrc}
          type="text/javascript"
          data-liquid="true"
          data-cookieconsent="ignore"
        />
      </div>
    );
  }

  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.videoPosition === 'left') {
    // render videos under main content if the video position is set to 'left'
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className="col-1-of-2 main-content content-lg">
      <h1>{article.title}</h1>
      <ArticleImage imageUrl={article.imageLeftTopUrl} imageAlt={article.imageLeftTopAlt} />
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      {WidgetRenderer.renderWidgets(widgets, 'before-main-content')}
      <div dangerouslySetInnerHTML={{ __html: article.mainContent }} />
      <CallToAction
        callToActionText={article.callToActionText}
        callToActionLink={article.callToActionLink}
      />
      {whofinanceWidget()}
      {vimeoVideo}
      {youtubeVideo}
      {WidgetRenderer.renderWidgets(widgets, 'main-content-before-form')}
      {FormRenderer.displayFor(article, 'main_content')}
      {FormRenderer.formInModal(article, 'modal_main_content')}
      {WidgetRenderer.renderWidgets(widgets, 'main-content')}
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
    </div>
  );
}

MainContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

function Consultants({ consultantIds, parentArticleId }) {
  const consultantDivs = consultantIds.map((element, index) => (
    <div className="col-1-of-3" key={index}>
      <ConsultantTeaser articleId={element} parentArticleId={parentArticleId} />
    </div>
  ));

  return <div className="row consultants-teaser">{consultantDivs}</div>;
}

Consultants.propTypes = {
  consultantIds: React.PropTypes.array,
  parentArticleId: React.PropTypes.number
};

function Summary({ article }) {
  if (!article.summary) {
    return null;
  }

  return (
    <div className="container">
      <div className="row">
        <aside className="sidebar">&nbsp;</aside>

        <article className="content margin-top-md margin-bottom-xs">
          <div dangerouslySetInnerHTML={{ __html: article.summary }} />
        </article>

        <aside className="spacebar">&nbsp;</aside>
      </div>
    </div>
  );
}

Summary.propTypes = {
  article: React.PropTypes.object
};

function Events({ t, showEventSection, eventIds, parentArticleId, branchCity, article }) {
  if (!showEventSection) {
    return null;
  }

  const eventDivs = eventIds.map((element, index) => (
    <ListTeaser articleId={element} parentArticleId={parentArticleId} key={index} />
  ));
  let headline = `${t('noEvents')} ${branchCity}`;
  let content = (
    <div className="container">
      <div className="row">
        <aside className="sidebar">&nbsp;</aside>

        <article className="content no-margin-top margin-bottom-xs">
          <div className="row">{FormRenderer.displayFor(article, 'bottom_content')}</div>
        </article>

        <aside className="spacebar">&nbsp;</aside>
      </div>
    </div>
  );

  if (eventIds.length) {
    headline = !!branchCity && `${t('eventsIn')} ${branchCity}`;
    content = eventDivs;
  }

  return (
    <div className="event-teaser" id="branch-events">
      {!!headline && (
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className="content margin-top-md margin-bottom-xs">
              <div className="row">
                <h1 className="no-margin">{headline}</h1>
              </div>
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
      )}
      {content}
    </div>
  );
}

Events.propTypes = {
  t: React.PropTypes.func,
  showEventSection: React.PropTypes.bool,
  eventIds: React.PropTypes.array,
  parentArticleId: React.PropTypes.number,
  branchCity: React.PropTypes.string,
  article: React.PropTypes.object
};

function FurtherContent({ article, widgets }) {
  function branchLocation() {
    if (!article.branch.location) {
      return null;
    }

    return (
      <span>
        {article.branch.city}
        <br />
        {article.branch.location.street}
        <br />
        {article.branch.location.zip} {article.branch.location.city}
      </span>
    );
  }

  function branchPhone() {
    if (!article.branch.phone) {
      return null;
    }

    return (
      <span>
        <span>T</span>&nbsp;
        <a
          className="link-unstyled"
          href={`tel:${article.branch.phone}`}
          title="Niederlassung anrufen"
        >
          {article.branch.phone}
        </a>
        <br />
      </span>
    );
  }

  function branchFax() {
    if (!article.branch.fax) {
      return null;
    }

    return (
      <span>
        <span>F</span> {article.branch.fax}
        <br />
      </span>
    );
  }

  function branchEMail() {
    if (!article.branch.email) {
      return null;
    }

    return (
      <span>
        <a
          href={`mailto:${article.branch.email}`}
          title={`E-Mail an ${article.branch.email}`}
          className="link-unstyled"
        >
          {article.branch.email}
        </a>
        <br />
      </span>
    );
  }

  function branchOpeningHours() {
    if (!article.branch.opening_hours) {
      return null;
    }

    return (
      <div className="color-secondary margin-bottom-xs">
        Servicezeiten
        <br />
        <div dangerouslySetInnerHTML={{ __html: article.branch.opening_hours }} />
      </div>
    );
  }

  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.videoPosition === 'right') {
    // render videos in further content if the selected video position is 'right'
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );

    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className="col-1-of-2 further-content content-sm">
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      <div className="hidden-mobile">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: article.furtherContent }} />
      <div>
        <div>
          {WidgetRenderer.renderActionWidget('branch', article)}
          <p className="color-secondary">{branchLocation()}</p>
          <p className="color-secondary">
            {branchPhone()}
            {branchFax()}
            {branchEMail()}
          </p>
          {branchOpeningHours()}
        </div>
      </div>
      <div className="clearfix" />
      {vimeoVideo}
      {youtubeVideo}
      {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
      {FormRenderer.displayFor(article, 'further_content')}
      {FormRenderer.formInModal(article, 'modal')}
      {WidgetRenderer.renderWidgets(widgets, 'further-content')}
      <div className="hidden-desktop">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
    </div>
  );
}

FurtherContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

export default translate()(BranchArticle);



// WEBPACK FOOTER //
// ./components/articles/branchArticle.js